import { Injectable } from '@angular/core';
import {
    RepositoryService,
    FilterParams,
    FilterResult,
} from '../../../helpers/crud/repository.service';

import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { EnumRepositoryService } from '../../../helpers/crud/enumRepository.service';

import { from } from 'rxjs/internal/observable/from';
import { Face } from './campaign.model';
import { DayOfWeekFlags } from '../../park/park.model';

@Injectable()
export class FaceService extends RepositoryService<Face> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'faces');
    }

    getKeyValyeById(id: number) {
        return this.http.get<any>(`${this.url}/getKeyValueById/${id}`);
    }

    getFaceName(id: number) {
        return this.http.get<any>(`${this.url}/getFaceName/${id}`);
    }

    getFacesArroundMe(latitude: any, longitude: any) {
        const facesAroundMeParams = new FaceArroundMeParams();
        facesAroundMeParams.latitude = latitude;
        facesAroundMeParams.longitude = longitude;

        return this.http.post<any[]>(
            `${this.url}/getFacesArroundMe`,
            facesAroundMeParams
        );
    }

    getFilteredFaceIds(filter: FilteredFaceDetailsParams) {
        return this.http.post<number[]>(`${this.url}/getFilteredFaceDetails`, filter);
    }

    getFilteredFaceDetails(filter: FilteredFaceDetailsParams) {
        return this.http.post<GetFilteredFaceDetailsOutput>(
            `${this.url}/getFilteredFaceDetails`,
            filter
        );
    }

    changePictureFace(faceId: number, fileId: number) {
        return this.http.post(`${this.url}/changePictureFace`, { faceId: faceId, fileId: fileId });
    }

    removePictureFace(faceId: number) {
        return this.http.delete(`${this.url}/RemovePictureFace/${faceId}`);
    }
}

@Injectable()
class FacePlaylistService extends RepositoryService<Face> {
    constructor(http: WancomHttpService, waiting$: WaitingService) {
        super(http, waiting$, 'faces');
    }

    getPlaylist(faceId: number) {
        return this.http.get<FilterResult<string>>(
            `${this.url}/playlist/${faceId}`
        );
    }
}

export class FaceFilterParams extends FilterParams {
    search?: string;
    id?: number;
    OrganizationId?: number;
    spotId?: number;
    campaignId?: number;
    faceId?: number;
    groupBy?: number;
    groupById?: number;
}

class FaceArroundMeParams {
    longitude: any;
    latitude: any;
}

export class FilteredFaceDetailsParams extends FaceFilterParams {
    /**
     * Tags Id list
     */
    tags?: number[];
    /**
     * Faces Id List
     */
    faceIds?: number[];
    /**
     * Current diffusion Id
     * For returning selectd faces
     */
    diffusionId?: number;

    // Champs de recherche
    search?: string;
}

export class FilteredFaceDetailsResult {
    /**
     * Id `number`
     */
    i: number;
    /**
     * ThumbnailStorageId = StoredFile(s3),
     */
    t?: string;
    /**
     * Video/File/StorageId = StoredFile(s3)
     */
    f?: string;
    /**
     * Id Tags
     *  */
    ts?: any[];
    /**
     * NbDiff
     */
    nd?: number;
    /**
     * NbTickets
     */
    nt?: number;
    /**
     *  durationLoop : int (secondes)
     */
    d?: number;
    /**
     * La face est-elle compatible
     */
    e?: boolean;
    /**
     * CityName
     */
    cn?: string;
    /**
     * ScreenCode
     */
    sc?: string;
    /**
     * Screen Height
     * Hauteur de la face en px
     */
    sh?: number;
    /**
     * Screen Width
     * 
     * Largeur de la face en px
     */
    sw?: number;
    fnw?: any;
    /**
     * Screen Address
     */
    sa?: string;
    /**
     * ZipCode
     */
    cz?: string;
}

export class FilteredGroupFaceDetailsResult {
    /**
     * Nom de l'orga 
     * OrganizationName
     */
    k: string;
    /**
     * Liste des faces
     */
    l: FilteredFaceDetailsResult[];
    /**
     * Id de la face
     */
    faceId?: number;
}

interface GetFilteredFaceDetailsOutput {
    /**
     * Filtered result of getFilteredFaceDetails/
     */
    ret: FilterResult<FilteredGroupFaceDetailsResult>;
    /**
     * Already selected face Ids
     */
    sf: number[];
}
